import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  SidebarComponent,
  SidebarMenuItem,
  SidebarCallToAction,
  SidebarFooterItem,
} from '../../shared/components/sidebar/sidebar.component';

@Component({
  selector: 'app-admin-sidebar',
  standalone: true,
  imports: [CommonModule, SidebarComponent],
  templateUrl: './admin-sidebar.component.html',
  styleUrl: './admin-sidebar.component.scss',
})
export class AdminSidebarComponent {
  menuItems: SidebarMenuItem[] = [
    {
      label: 'Dashboard',
      route: '/admin/home',
      iconUrl: '/icons/dashboard.svg',
    },
    {
      label: 'My Activities',
      route: '/admin/activities',
      iconUrl: '/icons/activities.svg',
    },
    {
      label: 'User Activities',
      route: '/admin/user-activities',
      iconUrl: '/icons/activities.svg',
    },
    {
      label: 'Asset',
      icon: '<path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
      children: [
        {
          label: 'Manage Platform Assets',
          route: '/admin/contributions',
        },
        {
          label: 'Asset File Upload',
          route: '/admin/data-upload-requests',
        },
      ],
    },
    {
      label: 'Manage Platform',
      iconUrl: '/icons/files.svg',
      children: [
        {
          label: 'Platform Users',
          route: '/admin/view-all-users',
        },
        {
          label: 'Organisation Requests',
          route: '/admin/new-requests',
        },
        {
          label: 'Manage Organisations',
          route: '/admin/existing-entities',
        },
        {
          label: 'Credit / Compute Requests',
          route: '/admin/credit-compute',
        },
        {
          label: 'Manage Challenge ',
          route: '/admin/challenge',
        },
      ],
    },
  ];

  callToAction: SidebarCallToAction | undefined = undefined;

  footerItems: SidebarFooterItem[] = [
    {
      label: 'Profile',
      route: '/admin/profile',
      iconUrl: '/icons/person.svg',
    },
    {
      label: 'Support',
      route: '/admin/support',
      iconUrl: '/icons/support.svg',
    },
  ];
}
